import MouseTracker from './mouse-tracker.class';

const mouseTracker = new MouseTracker();
let initialized = false;

export default {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          mouseTracker,
        };
      },
      created() {
        if (!initialized) {
          mouseTracker.init();
        }
      },
    });
  },
};
